import React from 'react';
import { observer } from 'mobx-react';
import { isObservableArray } from 'mobx';
import { Link } from 'react-router';

// Helpers
import { getParam, toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';
import LoadMore from '../Common/LoadMore';

const Report = observer(class Report extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleClick = this.handleClick.bind(this);
    this.reportActions.toggleLock = this.reportActions.toggleLock.bind(this);
  }

  componentWillMount() {
    // Apply default course offering filter on mount
    this.props.store.ReportStore.defaultCourseOffering = true;
  }

  handleClick(e, action, actionType, sids) {
    if(actionType === 'drawer') {
      e.preventDefault();

      const _this = this;
      const url = e.target.href;
      const examSid = getParam('exam', url);
      const sessionSid = getParam('session', url);
      const courseSid = getParam('course', url);

      this.props.parent.setState({
        examSid,
        sessionSid,
        courseSid
      }, function(){
        toggleDrawer(null, _this.props.parent, action);
      });
    } else {
      this.reportActions[action](sids, e);
    }
  }

  reportActions = {
    toggleLock(sids, e) {
      let data = {
        approved: true,
        locked: true
      }

      if(e.target.getAttribute('title') === 'Click to lock') {
        // Exam is currently unlocked, so we’ll lock it
        e.target.className = e.target.className.replace('report-unlocked', 'report-locked');
        e.target.innerHTML = 'Locked';
        e.target.setAttribute('title', 'Click to unlock');
      } else {
        // Exam is currently locked, so we’ll unlock it
        data.locked = false;

        e.target.className = e.target.className.replace('report-locked', 'report-unlocked');
        e.target.innerHTML = 'Unlocked';
        e.target.setAttribute('title', 'Click to lock');
      }

      this.props.store.ExamStore.updateConfigurationStatus(sids.examSid, sids.configurationSid, data, null, true);
    },
  }


  render() {
    const _this = this;
    const { reportData, translation } = this.props;
    const { ReportStore, SessionStore } = this.props.store;
    const { appendReportData, reportFormat, reportNext } = ReportStore;
    const { userTimezone } = SessionStore;

    let group = null;
    let concat = false;

    function renderData(element, index) {
      if(element && typeof element === 'object' && !Array.isArray(element)) {
        // If it’s an object, check for a URL and title
        if(element.url && element.title) {
          // If it’s a link, output an anchor tag
          if(element.target && element.target === '_self') {
            return (
              <li key={index}>
                <Link
                  to={element.url}
                  className={element.class}
                  onClick={(e) => {_this.handleClick(e, element.action, element.actionType)}}
                >
                  {element.title}
                </Link>
              </li>
            )
          } else {
            return (
              <li key={index}>
                <a
                  href={element.url}
                  target="_blank"
                  className={element.class}
                  onClick={(e) => {_this.handleClick(e, element.action, element.actionType)}}
                >
                  {element.title}
                </a>
              </li>
            )
          }
        } else if(element.button) {
          return (
            <li key={index}>
              <button
                className={element.class}
                type="button"
                onClick={(e) => {_this.handleClick(e, element.action, null, element.sids)}}
                title={element.helper}
              >
                {element.title}
              </button>
            </li>
          )
        } else if(element.raw && element.formatted) {
          // Otherwise, if it’s raw and formatted data, output the formatted data
          return element.formatted;
        } else {
          // If it’s not a link, loop through the keys
          return (
            Object.keys(element).map(
              (key, i) => {
              if(element[key]) {
                return (
                  <li key={i}>
                    {key === 'examType' && element[key].toLowerCase() === 'written' &&
                      <icons.iconPencilPaper />
                    }

                    {key === 'examType' && element[key].toLowerCase() === 'online' &&
                      <icons.iconLaptop />
                    }

                    {moment(element[key], moment.ISO_8601).isValid() &&
                      <time>{moment(element[key]).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}</time>
                    }
                    {(!moment(element[key], moment.ISO_8601).isValid() && typeof element[key] === 'object' && element[key].url && !element[key].mailto) &&
                      <Link to={element[key].url} target="_blank">{element[key].title}</Link>
                    }
                    {(!moment(element[key], moment.ISO_8601).isValid() && typeof element[key] === 'object' && element[key].mailto) &&
                      <a href={element[key].url}>{element[key].title}</a>
                    }
                    {(!moment(element[key], moment.ISO_8601).isValid() && typeof element[key] === 'object' && element[key].onClick) &&
                      <button
                        className="btn"
                        onClick={_this[element[key].onClick]}
                        data-sid={element[key].sid}
                      >
                        {element[key].title}
                      </button>
                    }
                    {(!moment(element[key], moment.ISO_8601).isValid() && typeof element[key] === 'object' && !element[key].url && !element[key].onClick) &&
                      <span>object</span>
                    }
                    {((!moment(element[key], moment.ISO_8601).isValid() && typeof element[key] !== 'object')) &&
                      element[key]
                    }
                  </li>
                )
              }

              return null;
            })
          )
        }
      } else {
        return (
          <li key={index}>{element}</li>
        )
      }
    }

    if(!SessionStore.loading) {
      if(reportData && reportData.length > 0) {
        if(!this.props.disableScroll) {
          return (
            <div className="table-scrollable">
              <div className="table-wrap">
                <table className="report-table">
                  {this.props.caption &&
                    <caption>{this.props.caption}</caption>
                  }

                  <thead>
                    <tr>
                      {Object.keys(reportData[0]).map(
                        (key, i) =>
                        <th
                          id={`heading-${i}`}
                          key={i}
                          scope="col"
                          className={`subtitle column-${key}`}
                        >
                          {translation[key] || key}

                          <div
                            className={`th-fixed column-${key}`}
                            data-direction="asc"
                            aria-hidden="true"
                          >
                            {translation[key] || key}
                          </div>
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {/* Loop through each array object then loop through each object key to output the data in the correct column */}
                    {reportData.map(
                      (key, i) =>
                      <tr key={i}>
                        {Object.keys(reportData[0]).map(
                          (column, j) => {
                            if(
                              reportData[i][column] &&
                              typeof reportData[i][column] === 'object' &&
                              !isObservableArray(reportData[i][column]) &&
                              !React.isValidElement(reportData[i][column])
                            ) {

                              // If the data is an object, loop through it
                              return (
                                <td
                                  aria-labelledby={`heading-${j}`}
                                  key={j}
                                  data-col={column}
                                  className={`column-${column}`}
                                  data-value={reportData[i][column].raw || ''}
                                >
                                  <ul className="table-list">
                                    {renderData(reportData[i][column])}
                                  </ul>
                                </td>
                              )
                            } else if(isObservableArray(reportData[i][column])) {
                              // Otherwise, if it’s an array, loop through that
                              return (
                                <td
                                  aria-labelledby={`heading-${j}`}
                                  key={j}
                                  data-col={column}
                                  className={`column-${column}`}
                                >
                                  <ul className="table-list">
                                    {reportData[i][column].map(
                                      (subKey, k) =>
                                      renderData(subKey, k)
                                    )}
                                  </ul>
                                </td>
                              )
                            } else if(React.isValidElement(reportData[i][column])) {
                              // Otherwise, if it’s an element, output it
                              return (
                                <td
                                  aria-labelledby={`heading-${j}`}
                                  key={j}
                                  data-col={column}
                                  className={`column-${column}`}
                                >
                                  {reportData[i][column]}
                                </td>
                              )
                            } else {
                              // Otherwise, just output the data
                              return (
                                <td
                                  aria-labelledby={`heading-${j}`}
                                  key={j}
                                  className={`${typeof reportData[i][column] === 'number' ? 'number' : ''} column-${column}`}
                                  data-col={column}
                                  data-value={reportData[i][column]}
                                >
                                  <div>
                                    {column === 'examType' && reportData[i][column].toLowerCase() === 'written' &&
                                      <icons.iconPencilPaper />
                                    }

                                    {column === 'examType' && reportData[i][column].toLowerCase() === 'online' &&
                                      <icons.iconLaptop />
                                    }


                                    {/* If it’s a date, format it */}
                                    {moment(reportData[i][column], moment.ISO_8601).isValid() &&
                                      <time>{moment(reportData[i][column]).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}</time>
                                    }

                                    {/* Otherwise, just output it */}
                                    {!moment(reportData[i][column], moment.ISO_8601).isValid() &&
                                      <div
                                        className="capitalize"
                                        dangerouslySetInnerHTML={{
                                          __html: DOMPurify.sanitize(reportData[i][column])
                                        }}
                                      />
                                    }
                                  </div>
                                </td>
                              )
                            }
                          }
                        )}
                      </tr>
                    )}
                  </tbody>
                </table>

                {reportNext &&
                  <LoadMore
                    url={reportNext}
                    text="Load more results"
                    dataFormat={reportFormat}
                    dataSet={appendReportData}
                    concat={concat}
                    group={group}
                    wrapper={'.table-wrap'}
                    {...this.props}
                  />
                }
              </div>
            </div>
          )
        } else {
          return (
            <table className="report-table wrapped-table">
              {this.props.caption &&
                <caption>{this.props.caption}</caption>
              }

              <thead>
                <tr>
                  {Object.keys(reportData[0]).map(
                    (key, i) =>
                    <th
                      id={`heading-${i}`}
                      key={i}
                      scope="col"
                      className={`column-${key}`}
                    >
                      {translation[key] || key}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {/* Loop through each array object then loop through each object key to output the data in the correct column */}
                {reportData.map(
                  (key, i) =>
                  <tr key={i}>
                    {Object.keys(reportData[0]).map(
                      (column, j) =>
                      {
                        if(reportData[i][column] && typeof reportData[i][column] === 'object' && !isObservableArray(reportData[i][column])) {
                          // If the data is an object, loop through it
                          return (
                            <td
                              aria-labelledby={`heading-${j}`}
                              key={j}
                              data-col={column}
                              className={`column-${column}`}
                              data-value={reportData[i][column].raw || ''}
                            >
                              <ul className="table-list">
                                {renderData(reportData[i][column])}
                              </ul>
                            </td>
                          )
                        } else if(isObservableArray(reportData[i][column])) {
                          // Otherwise, if it’s an array, loop through that
                          return (
                            <td
                              aria-labelledby={`heading-${j}`}
                              key={j}
                              data-col={column}
                              className={`column-${column}`}
                            >
                              <ul className="table-list">
                                {reportData[i][column].map(
                                  (subKey, k) =>
                                  renderData(subKey, k)
                                )}
                              </ul>
                            </td>
                          )
                        } else {
                          // Otherwise, just output the data
                          return (
                            <td
                              aria-labelledby={`heading-${j}`}
                              key={j}
                              className={`${typeof reportData[i][column] === 'number' ? 'number' : ''} column-${column}`}
                              data-col={column}
                              data-value={reportData[i][column]}
                            >
                              {(column === 'examType' || column === 'examByWeekType') && reportData[i][column].toLowerCase() === 'written' &&
                                <icons.iconPencilPaper />
                              }

                              {(column === 'examType' || column === 'examByWeekType') && reportData[i][column].toLowerCase() === 'online' &&
                                <icons.iconLaptop />
                              }

                              {/* If it’s a date, format it */}
                              {moment(reportData[i][column], moment.ISO_8601).isValid() &&
                                <time>{moment(reportData[i][column]).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}</time>
                              }

                              {/* Otherwise, just output it */}
                              {!moment(reportData[i][column], moment.ISO_8601).isValid() &&
                                reportData[i][column]
                              }
                            </td>
                          )
                        }
                      }
                    )}
                  </tr>
                )}
              </tbody>
            </table>
          )
        }
      } else {
        return (
              <span className="no-results">{translation.no_results}</span>
      )
      }
    }

    return null;
  }
})

export default translate('Report')(Report);



// WEBPACK FOOTER //
// ./src/app/components/Reports/Report.js